import { useEffect, useState } from 'react';

/**
 * Reading progress bar that fills as the user scrolls through article content.
 * Sticky at the very top of the viewport. Uses pageYOffset / scrollHeight.
 */
const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const totalScrollable = (h.scrollHeight - h.clientHeight) || 1;
      const pct = Math.min(100, Math.max(0, (h.scrollTop / totalScrollable) * 100));
      setProgress(pct);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 h-1 bg-transparent pointer-events-none"
      data-testid="reading-progress-bar"
    >
      <div
        className="h-full bg-gradient-to-r from-[#0072BB] to-[#00A6E2] transition-[width] duration-150 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ReadingProgressBar;
